var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _vm.loading
      ? _c("div", { staticClass: "box" }, [
          _c(
            "div",
            { staticClass: "box-content text-center text-muted py-4" },
            [_vm._v("Loading…")]
          ),
        ])
      : !_vm.rows.length
      ? _c("div", { staticClass: "box" }, [
          _c(
            "div",
            { staticClass: "box-content text-center text-muted py-4" },
            [_vm._v("No Brightfish admissions found.")]
          ),
        ])
      : _c("div", { staticClass: "box" }, [
          _c("div", { staticClass: "box-content" }, [
            _c(
              "div",
              { staticClass: "d-flex align-items-center mb-2" },
              [
                _c("heading", {
                  staticClass: "flex-grow-1",
                  attrs: {
                    upper: "Admissions per cinema year",
                    lower: _vm.rows.length + " cinema years, sales house BF",
                    border: "",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "btn-group btn-group-sm ml-3" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn",
                      class:
                        _vm.mode === "admissions"
                          ? "btn-secondary"
                          : "btn-outline-secondary",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          _vm.mode = "admissions"
                        },
                      },
                    },
                    [_vm._v("Admissions")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn",
                      class:
                        _vm.mode === "pct"
                          ? "btn-secondary"
                          : "btn-outline-secondary",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          _vm.mode = "pct"
                        },
                      },
                    },
                    [_vm._v("% of year")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn",
                      class:
                        _vm.mode === "movies"
                          ? "btn-secondary"
                          : "btn-outline-secondary",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          _vm.mode = "movies"
                        },
                      },
                    },
                    [_vm._v("# Movies")]
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c("table", { staticClass: "shx-table w-100 mt-2" }, [
              _c("thead", [
                _c(
                  "tr",
                  [
                    _c("th", { staticClass: "shx-th-100" }, [
                      _vm._v("Cinema year"),
                    ]),
                    _vm._v(" "),
                    _c("th", { staticClass: "text-right shx-th-80" }, [
                      _vm._v("# Weeks"),
                    ]),
                    _vm._v(" "),
                    _c("th", { staticClass: "text-right" }, [
                      _vm._v("Preshow (BF)"),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.tags, function (tag) {
                      return _c(
                        "th",
                        { key: tag || "none", staticClass: "text-right" },
                        [
                          _c("span", { class: { "text-muted": !tag } }, [
                            _vm._v(_vm._s(_vm.tagLabel(tag))),
                          ]),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c("th", { staticClass: "shx-th-100" }),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.rows, function (row) {
                  return _c(
                    "tr",
                    { key: row.year },
                    [
                      _c(
                        "td",
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: "/admissions/movie-tag/" + row.year,
                              },
                            },
                            [_vm._v(_vm._s(row.year))]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _vm._v(_vm._s(row.weeks)),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.formatInt(row.admissions))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.tags, function (tag) {
                        return _c(
                          "td",
                          { key: tag || "none", staticClass: "text-right" },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.cell(row, tag)) +
                                "\n                        "
                            ),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "btn btn-sm btn-outline-secondary",
                              attrs: {
                                to: "/admissions/movie-tag/" + row.year,
                              },
                            },
                            [
                              _vm._v(
                                "\n                                Detail\n                            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("tfoot", [
                _c(
                  "tr",
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _c("strong", [_vm._v(_vm._s(_vm.totalWeeks))]),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.formatInt(_vm.totalAdmissions))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.tags, function (tag) {
                      return _c(
                        "td",
                        { key: tag || "none", staticClass: "text-right" },
                        [_c("strong", [_vm._v(_vm._s(_vm.totalCell(tag)))])]
                      )
                    }),
                    _vm._v(" "),
                    _c("td"),
                  ],
                  2
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "text-muted small mt-2 mb-0" }, [
              _vm._v(
                "\n                A cinema year runs from week C01 to the last cinema week (Wednesday to Tuesday).\n                Only rows with "
              ),
              _c("code", [_vm._v("saleshouse = BF")]),
              _vm._v(
                " count. The tag is the Movix target pack of the movie\n                ("
              ),
              _c("code", [_vm._v("movix_history.movie_tag")]),
              _vm._v("); "),
              _c("em", [_vm._v(_vm._s(_vm.tagLabel(null)))]),
              _vm._v(
                " collects titles without a\n                Movix id, without a history row or without a tag. Tags exist since cinema year " +
                  _vm._s(_vm.bucket.first_tag_year) +
                  "\n                (from 2023C50); earlier years are not reported. The historic "
              ),
              _c("code", [_vm._v("v2-adolescent")]),
              _vm._v("\n                spelling is counted as "),
              _c("code", [_vm._v("v2-adolescents")]),
              _vm._v(".\n                Same data as JSON: "),
              _c("code", [_vm._v("GET /api/v1/admissions/movie-tag")]),
              _vm._v(".\n            "),
            ]),
          ]),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "box view-nav-bar" }, [
      _c("div", { staticClass: "d-flex align-items-center w-100" }, [
        _c("div", { staticClass: "flex-grow-1" }, [
          _c("strong", [_vm._v("Per movie tag")]),
          _vm._v(" "),
          _c("span", { staticClass: "text-muted ml-2" }, [
            _vm._v(
              "— Brightfish preshow admissions (sales house BF) per cinema year, split per Movix target-pack tag"
            ),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [_c("strong", [_vm._v("Total")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }